import {
    FETCH_CREATE_PRODUCTS_REQUEST,
    FETCH_CREATE_PRODUCTS_SUCCESS,
    FETCH_CREATE_PRODUCTS_FAILURE,
} from '../../actions/products/create-product-action';

const initialState = {
    createdProduct: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const CreateProductReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_CREATE_PRODUCTS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_CREATE_PRODUCTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                createdProduct: { ...action.payload[0] },
            };
        case FETCH_CREATE_PRODUCTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default CreateProductReducer;